// extracted by mini-css-extract-plugin
export var bubble = "_37-0";
export var container = "_37-3";
export var contrastBorder = "_37-4";
export var greyOut = "_37-2";
export var initialsWrapper = "_37-1";
export var large = "_37-9";
export var medium = "_37-8";
export var mediumSmall = "_37-7";
export var mediumSmallMedium = "_37-c";
export var micro = "_37-5";
export var small = "_37-6";
export var tiny = "_37-b";
export var xTiny = "_37-a";